var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0.5C57.9345 0.5 74.5 17.0655 74.5 37.5C74.5 57.9345 57.9345 74.5 37.5 74.5C17.0655 74.5 0.5 57.9345 0.5 37.5C0.5 17.0655 17.0655 0.5 37.5 0.5Z",
    fill: "black",
    stroke: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4417 47.6282L36.132 31.2015C36.4961 30.8412 36.9877 30.6392 37.5 30.6392C38.0122 30.6392 38.5038 30.8412 38.868 31.2015L55.5583 47.6246C55.9247 47.9847 56.4179 48.1865 56.9316 48.1865C57.4454 48.1865 57.9386 47.9847 58.305 47.6246C58.4854 47.4487 58.6288 47.2385 58.7267 47.0063C58.8246 46.7741 58.8751 46.5246 58.8751 46.2727C58.8751 46.0207 58.8246 45.7712 58.7267 45.539C58.6288 45.3068 58.4854 45.0966 58.305 44.9207L41.6182 28.4976C40.5191 27.4184 39.0403 26.8138 37.5 26.8138C35.9596 26.8138 34.4808 27.4184 33.3817 28.4976L16.695 44.9207C16.514 45.0967 16.3701 45.3071 16.2719 45.5396C16.1737 45.7722 16.123 46.022 16.123 46.2744C16.123 46.5269 16.1737 46.7767 16.2719 47.0092C16.3701 47.2418 16.514 47.4522 16.695 47.6282C17.0614 47.9883 17.5546 48.19 18.0683 48.19C18.5821 48.19 19.0752 47.9883 19.4417 47.6282Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.15d383603c9c31b5162c5bcad099f2cf.svg";
export { ForwardRef as ReactComponent };